<template>
  <div class="history">
    <div class="container-xl">
      <!-- BACK -->
      <b-button size="sm" variant="outline-danger" @click="backToDashboard">
        <i class="fa fa-arrow-left mr-1"></i>
        {{ $t('label.back') }}
      </b-button>

      <h2 class="mt-3">{{ $t('label.historyCalling') }}</h2>

      <!-- FILTER -->
      <div class="row mb-3 g-2 mt-3 filter-box">
        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="font-weight-bold">{{ $t('label.status') }}</label>
          <b-form-select v-model="filter.status" :options="optionsStatusFilter" />
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="font-weight-bold">{{ $t('label.fromDate') }}</label>
          <input type="date" class="form-control" v-model="filter.fromDate" />
        </div>

        <div class="col-xl-3 col-lg-4 col-md-6">
          <label class="font-weight-bold">{{ $t('label.toDate') }}</label>
          <input type="date" class="form-control" v-model="filter.toDate" />
        </div>

        <div class="col-12 d-flex gap-2 mt-4">
          <b-button variant="primary" @click="searchHistory">
            {{ $t('label.search') }}
          </b-button>
          <b-button variant="outline-success" @click="resetFilter">
            <i class="fa fa-refresh mr-1"></i> Đặt lại
          </b-button>
        </div>
      </div>

      <!-- TABLE -->
      <div class="table-scroll">
        <b-table class="customer-table"
        bordered hover head-variant="dark" :items="dataTable" :fields="fields">
          <template #cell(stt)="data">
            {{ data.index + 1 + (currentPage - 1) * perPage }}
          </template>

          <template #cell(status)="data">
            <span class="status-item" :class="statusClass(data.item.status)">
              {{ statusText(data.item.status) }}
            </span>
          </template>

          <template #cell(note)="data">
            <div class="note-cell">
              <span v-if="data.item.note">{{ data.item.note }}</span>
              <span v-else class="text-muted">—</span>
            </div>
          </template>

          <template #cell(customer_order_id)="data">
            <span v-if="data.item.customer_order_id">Đã đặt đơn</span>
            <span v-else>_</span>
          </template>

          <template #cell(action)="data">
            <div class="action-icons">
              <b-button size="sm" variant="link" class="icon-btn text-info" title="Xem chi tiết"
                @click="goToDetail(data.item)">
                <i class="fa fa-eye"></i>
              </b-button>

              <b-button size="sm" variant="link" class="icon-btn text-success" title="Kiểm tra đơn hàng"
                @click="openCheckOrderModal(data.item)">
                <i class="fa fa-search"></i>
              </b-button>

              <b-button size="sm" variant="link" class="icon-btn text-primary" title="Chỉnh sửa"
                @click="openEditModal(data.item)">
                <i class="fa fa-edit"></i>
              </b-button>

              <b-button v-if="data.item.note" size="sm" variant="link" class="icon-btn text-danger" title="Xoá"
                @click="openDeleteModal(data.item)">
                <i class="fa fa-trash"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>

      <!-- PAGINATION -->
      <div class="d-flex justify-content-between mt-3 flex-wrap">
        <small class="text-muted">
          Hiển thị
          {{ (currentPage - 1) * perPage + 1 }}
          –
          {{ Math.min(currentPage * perPage, totalElements) }}
          /
          {{ totalElements }}
          bản ghi
        </small>

        <div class="d-flex">
          <b-form-select size="sm" v-model="selectedPerPage" :options="optionsPages" class="mr-2"
            style="max-width:100px" @change="changePerPage" />
          <b-pagination v-model="currentPage" :total-rows="totalElements" :per-page="perPage" size="sm"
            @change="changePage" />
        </div>
      </div>
    </div>

    <b-modal id="note-modal" title="Ghi chú khách hàng" ok-title="Lưu" centered cancel-title="Huỷ"
      :ok-disabled="!isNoteChanged" @ok="confirmSaveNote">
      <b-form-textarea v-model="noteContent" rows="4" placeholder="Nhập nội dung ghi chú..." />
    </b-modal>

    <b-modal id="delete-modal" centered title="Xác nhận xoá" ok-variant="danger" ok-title="Xoá" cancel-title="Huỷ"
      @ok="confirmDeleteNote">
      Bạn chắc chắn muốn xoá ghi chú này?
    </b-modal>

    <b-modal id="check-order-modal" title="Kiểm tra đơn hàng" ok-title="Kiểm tra" centered cancel-title="Huỷ"
      @ok="confirmCheckOrder">
      <div v-if="checkOrderMsg" class="text-danger">
        {{ checkOrderMsg }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      fields: [
        { key: 'stt', label: '#', thStyle: { width: '50px' }, tdClass: 'text-center' },
        { key: 'fullName', label: this.$t('label.customerName') },
        { key: 'phoneNumber', label: this.$t('label.phoneNumber') },
        { key: 'address', label: this.$t('label.address') },
        { key: 'note', label: this.$t('label.note') },
        { key: 'status', label: this.$t('label.status') },
        { key: 'customer_order_id', label: 'Trạng thái đơn hàng' },
        { key: 'actionDatetime', label: this.$t('label.datetimeCalling') },
        { key: 'action', label: 'Thao tác' }
      ],

      filter: { status: -1, fromDate: '', toDate: '' },

      dataTable: [],
      currentPage: 1,
      perPage: 20,
      selectedPerPage: 20,
      totalElements: 0,

      selectedItem: null,
      noteContent: '',
      customerOrderId: '',

      originalNote: '',

      checkOrderMsg: '',
      customer_order_id: '',

      optionsPages: [
        { value: 10, text: '10' },
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],

      optionsStatusFilter: [
        { value: -1, text: this.$t('label.all') },
        { value: 1, text: this.$t('label.orderStatusAccept') },
        { value: 2, text: this.$t('label.orderStatusReject') },
        { value: 3, text: this.$t('label.orderStatusNotPickUp') },
        { value: 4, text: this.$t('label.orderStatusNotCatch') },
        { value: 5, text: 'Cần tư vấn thêm' }
      ]
    }
  },

  computed: {
    isNoteChanged() {
      const newNote = (this.noteContent || '').trim()
      const oldNote = (this.originalNote || '').trim()
      return newNote !== oldNote && newNote.length > 0
    }
  },

  mounted() {
    this.getListHistory()
  },

  methods: {
    statusText(status) {
      return this.optionsStatusFilter.find(o => o.value === status)?.text || ''
    },

    openEditModal(item) {
      this.selectedItem = item
      this.noteContent = item.note || ''
      this.originalNote = item.note || ''
      this.$bvModal.show('note-modal')
    },


    openCheckOrderModal(item) {
      this.selectedItem = item
      this.customerOrderId = ''
      this.checkOrderMsg = ''
      this.$bvModal.show('check-order-modal')
    },

    statusClass(status) {
      return {
        accepted: status === 1,
        reject: status === 2,
        noAnswer: status === 3,
        notCatch: status === 4,
        consultation: status === 5
      }
    },

    async getListHistory() {
      const res = await apiClient.get('/api/v1/sale/customers', {
        params: {
          status: this.filter.status,
          fromDate: this.filter.fromDate || undefined,
          toDate: this.filter.toDate || undefined,
          perPage: this.perPage,
          currentPage: this.currentPage
        }
      })

      if (res?.data) {
        this.dataTable = res.data.items.map(i => ({
          id: i.id,
          fullName: i.full_name,
          phoneNumber: i.phone_number,
          assignmentId: i.assignment_id,
          address: i.address,
          note: i.note,
          status: i.status,
          actionDatetime: i.action_datetime_formatted,
          customer_order_id: i.customer_order_id
        }))
        this.totalElements = res.data.total
        this.currentPage = res.data.pageIndex
      }
    },

    async confirmCheckOrder() {
      this.checkOrderMsg = ''

      if (!this.selectedItem?.assignmentId) {
        this.checkOrderMsg = 'Không tìm thấy assignment'
        return
      }

      const payload = {
        orders: [
          {
            assignmentId: this.selectedItem.assignmentId
          }
        ]
      }

      try {
        const res = await apiClient.post(
          '/api/v1/sale/assignment/customer-order',
          payload
        )

        this.$bvToast.toast(
          res?.data?.message || 'Kiểm tra đơn hàng thành công',
          {
            title: 'Thành công',
            toaster: 'b-toaster-top-right',
            variant: 'success',
            solid: true
          }
        )

        this.$bvModal.hide('check-order-modal')
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || 'Kiểm tra đơn hàng thất bại'

        this.$bvToast.toast(errorMessage, {
          title: 'Thất bại',
          toaster: 'b-toaster-top-right',
          variant: 'danger',
          solid: true
        })
        this.checkOrderMsg = errorMessage
      }
    },

    async confirmSaveNote() {
      if (!this.isNoteChanged) return

      try {
        await apiClient.post('/api/v1/sale/customers/note', {
          customerId: this.selectedItem.id,
          note: this.noteContent
        })

        this.selectedItem.note = this.noteContent
        this.originalNote = this.noteContent

        this.$bvToast.toast('Cập nhật ghi chú thành công', {
          title: 'Thành công',
          toaster: 'b-toaster-top-right',
          variant: 'success',
          solid: true
        })
      } catch (error) {
        const message =
          error?.response?.data?.message || 'Cập nhật ghi chú thất bại'

        this.$bvToast.toast(message, {
          title: 'Lỗi',
          toaster: 'b-toaster-top-right',
          variant: 'danger',
          solid: true
        })
      }
    },

    openDeleteModal(item) {
      this.selectedItem = item
      this.$bvModal.show('delete-modal')
    },

    async confirmDeleteNote() {
      await apiClient.post('/api/v1/sale/customers/note', {
        customerId: this.selectedItem.id,
        note: null
      })

      this.selectedItem.note = null
       this.$bvToast.toast('Xóa ghi chú thành công!', {
          title: 'Thành công',
          toaster: 'b-toaster-top-right',
          variant: 'success',
          solid: true
        })
    },

    searchHistory() {
      this.currentPage = 1
      this.getListHistory()
    },

    resetFilter() {
      this.filter = { status: -1, fromDate: '', toDate: '' }
      this.searchHistory()
    },

    changePage(page) {
      this.currentPage = page
      this.getListHistory()
    },

    changePerPage() {
      this.currentPage = 1
      this.perPage = this.selectedPerPage
      this.getListHistory()
    },

    backToDashboard() {
      this.$router.replace('/sale')
    },

    goToDetail(item) {
      this.$router.push(`/sale/customer/${item.id}`)
    }
  }
}
</script>

<style scoped>
.label-page {
  line-height: 34px;
}

.table-scroll {
  overflow-x: auto;
}

.action-icons {
  display: flex;
  gap: 6px;
}

.icon-btn {
  padding: 4px;
  border: none !important;
  background: transparent !important;
}

.icon-btn:hover {
  opacity: 0.75;
}

.status-item {
  font-size: 12px;
  white-space: nowrap;
}

.status-item.accepted {
  color: #28a745;
}

.status-item.reject {
  color: #dc3545;
}

.status-item.noAnswer {
  color: #ffc107;
}

.status-item.notCatch {
  color: #6c757d;
}

.status-item.consultation {
  color: #17a2b8;
}

.note-cell {
  max-width: 250px;
  word-wrap: break-word;
  white-space: normal;
}
</style>
